<template lang="">
  <div>
    <div class="margin-top-lg">
      <div class="form-group row" style="margin-top: 40px;">
        <label class="col-2 col-form-label" style="color: Red"
          >姓名<span style="color: Red">*</span></label
        >
        <div class="col-10">
          <input
            name="name"
            type="text"
            class="form-control"
            v-model="name"
            @blur="nameBlur"
          />
          <p class="reds" v-if="isName">这是必填字段</p>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-2 col-form-label" style="color: Red"
          >身份证号<span style="color: Red">*</span></label
        >
        <div class="col-10">
          <input
            name="shenfenid"
            type="text"
            class="form-control"
            @blur="perinfoblur"
            v-model="personinfo"
          />
          <p class="reds" v-if="isPerinfo">这是必填字段</p>
          <p class="reds" v-if="isPerinfos">请输入正确的身份证号码</p>
          <p class="reds" v-if="isPerinfoss">
            您的身份证号不符合中国公民，请检查
          </p>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-2 col-form-label" style="color: Red"
          >联系电话(手 机)<span style="color: Red">*</span></label
        >
        <div class="col-10">
          <input
            name="phone"
            type="text"
            class="form-control"
            v-model="phonenum"
            @blur="phoneblur"
          />
          <p class="reds" v-if="isphonenum">这是必填字段</p>
          <p class="reds" v-if="isphonenums">请输入正确的手机号</p>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-2 col-form-label" style="color: Red"
          >联系地址<span style="color: Red">*</span></label
        >
        <div class="col-10">
          <input
            name="address"
            type="text"
            class="form-control"
            v-model="address"
            @blur="addressBlur"
          />
          <p class="reds" v-if="isAddress">这是必填字段</p>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-2 col-form-label" style="color: Red"
          >标题<span style="color: Red">*</span></label
        >
        <div class="col-10">
          <input
            name="title"
            type="text"
            class="form-control"
            v-model="titles"
            @blur="titlesBlur"
          />
          <p class="reds" v-if="isTitles">这是必填字段</p>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-2 col-form-label" style="color: Red"
          >内容<span style="color: Red">*</span></label
        >
        <div class="col-10">
          <textarea
            name="content"
            class="form-control"
            rows="5"
            v-model="cont"
            @blur="contBlur"
          ></textarea>
          <p class="reds" v-if="isCont">这是必填字段</p>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-2 col-form-label" style="color: Red"
          >是否保密<span style="color: Red">*</span></label
        >
        <!-- <label class="col-2 col-form-label">是否保密</label> -->
        <div class="col-10 flex" style="text-align: left;margin-top: 10px;">
          <div class="margin-right-lg">
            <div
              style="position: relative;"
              class="iradio_minimal-blue"
              :class="[isScr == 1 ? 'bluess' : 'notblues']"
            >
              <input
                id="RadioButton_PriviteOpen"
                type="radio"
                name="baomi"
                value="1"
                checked="checked"
                v-model="isScr"
                style="position: relative;opacity: 0;width: 18px;height: 18px;"
              />
            </div>
            <label for="RadioButton_PriviteOpen" class="privites">保密</label>
          </div>
          <div>
            <div
              style="position: relative;"
              class="iradio_minimal-blue"
              :class="[isScr == 2 ? 'bluess' : 'notblues']"
            >
              <input
                id="RadioButton_PriviteOpen2"
                type="radio"
                name="baomi"
                value="2"
                v-model="isScr"
                style="position: relative;opacity: 0;width: 18px;height: 18px;"
              />
            </div>
            <label for="RadioButton_PriviteOpen2" class="privites"
              >不保密</label
            >
          </div>
        </div>
      </div>
      <div class="form-group row">
        <button @click="subt" class="submit tjbutton" style="margin: 0 auto;">
          提交
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { liuyan } from "@/api/gxq";
export default {
  name: "LeaveMessage",
  data() {
    return {
      // 留言
      // 姓名
      name: "",
      isName: false,
      // 身份证号
      personinfo: "",
      isPerinfo: false,
      isPerinfos: false,
      isPerinfoss: false,
      // 电话
      phonenum: "",
      isphonenum: false,
      isphonenums: false,
      // 地址
      address: "",
      isAddress: false,
      // 标题
      titles: "",
      isTitles: false,
      // 内容
      cont: "",
      isCont: false,
      isScr: "1",
      // 留言结束
    };
  },
  methods: {
    async subt() {
      if (
        this.nameBlur() &&
        this.perinfoblur() &&
        this.phoneblur() &&
        this.addressBlur() &&
        this.titlesBlur() &&
        this.contBlur()
      ) {
        var data3 = {
          name: this.name,
          idcart: this.personinfo,
          phone: this.phonenum,
          address: this.address,
          title: this.titles,
          content: this.cont,
          is_baomi: this.isScr,
        };
        const { data } = await liuyan(data3);
        if (data.state == 0) {
          alert(data.msg);
          return false;
        }
        if (data.state == 1) {
          alert("提交成功");
          setTimeout(() => {
            this.name = "";
            this.personinfo = "";
            this.phonenum = "";
            this.address = "";
            this.titles = "";
            this.cont = "";
            (this.isScr = "1"), (this.isLb = true);
            // this.liebiao2(0);
            // this.currentIndex = 0;
          }, 500);
        }
      } else {
        this.nameBlur();
        this.perinfoblur();
        this.phoneblur();
        this.addressBlur();
        this.titlesBlur();
        this.contBlur();
      }
    },
    // 表单提交留言
    nameBlur() {
      var check = false;
      if (!this.name) {
        this.isName = true;
        check = false;
      } else {
        this.isName = false;
        check = true;
      }
      return check;
    },
    perinfoblur() {
      var check = false;
      let IDRe = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (!this.personinfo) {
        this.isPerinfo = true;
        check = false;
      } else if (!IDRe.test(this.personinfo)) {
        this.isPerinfos = true;
        this.isPerinfo = false;
        check = false;
      } else {
        this.isPerinfos = false;
        this.isPerinfo = false;
        check = true;
      }
      return check;
    },
    // 手机号
    phoneblur() {
      var check = false;
      let num = /^1[3456789]\d{9}$/;
      if (!this.phonenum) {
        // return false
        this.isphonenum = true;
        check = false;
      } else if (!num.test(this.phonenum)) {
        // return false
        this.isphonenums = true;
        this.isphonenum = false;
        check = false;
      } else {
        this.isphonenum = false;
        this.isphonenums = false;
        check = true;
      }
      return check;
    },
    // 地址
    addressBlur() {
      var check = false;
      if (!this.address) {
        this.isAddress = true;
        check = false;
      } else {
        this.isAddress = false;
        check = true;
      }
      return check;
    },
    titlesBlur() {
      var check = false;
      if (!this.titles) {
        this.isTitles = true;
        check = false;
      } else {
        this.isTitles = false;
        check = true;
      }
      return check;
    },
    contBlur() {
      var check = false;
      if (!this.cont) {
        this.isCont = true;
        check = false;
      } else {
        this.isCont = false;
        check = true;
      }
      return check;
    },
  },
};
</script>
<style scoped>
.reds {
  color: red;
}
.form-control {
  border: 1px solid #dadada;
  border-radius: 4px;
  max-width: 100%;
  font-size: 15px;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-transition: all 300ms linear;
  -moz-transition: all 300ms linear;
  -o-transition: all 300ms linear;
  transition: all 300ms linear;
}
.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.form-group {
  margin-bottom: 1rem;
}

.row {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}
@media screen and (min-width: 1200px) {
  .col-2,
  .privites {
    font-size: 1rem;
  }
}
@media screen and (min-width: 769px) and (max-width: 1199px) {
  .col-2,
  .privites {
    font-size: 0.9375rem;
  }
}
@media screen and (max-width: 768px) {
  .col-2,
  .privites {
    font-size: 0.875rem;
  }
}

.col-2 {
  -ms-flex: 0 0 16%;
  flex: 0 0 16%;
  max-width: 16%;
  text-align: right;
  margin-right: 5%;
}
.col-10 {
  -ms-flex: 0 0 58%;
  flex: 0 0 58%;
  max-width: 58%;
  text-align: right;
}
.form-control {
  border: 1px solid #dadada;
  border-radius: 4px;
  max-width: 100%;
  font-size: 15px;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-transition: all 300ms linear;
  -moz-transition: all 300ms linear;
  -o-transition: all 300ms linear;
  transition: all 300ms linear;
}
.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
textarea.form-control {
  min-height: 90px;
}
.tjbutton {
  background-attachment: scroll;
  background-clip: border-box;
  background-color: rgba(1, 107, 213, 1);

  border-image-source: none;
  border-image-width: 1;
  border-left-color: rgba(1, 107, 213, 1);
  border-left-style: solid;
  border-left-width: 1px;
  border-right-color: rgba(1, 107, 213, 1);
  border-right-style: solid;
  border-right-width: 1px;
  border-top-color: rgba(1, 107, 213, 1);
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  border-top-style: solid;
  border-top-width: 1px;
  box-sizing: border-box;
  color: rgb(255, 255, 255);
  cursor: pointer;
  display: inline-block;
  font-family: Roboto, sans-serif;
  font-size: 15px;
  font-weight: 400;
  height: 36px;
  line-height: 22.5px;
  outline-color: rgb(255, 255, 255);
  outline-style: none;
  outline-width: 0px;
  padding-bottom: 6px;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 6px;
  text-align: center;
  text-decoration-color: rgb(255, 255, 255);
  text-decoration-line: none;
  text-decoration-style: solid;
  text-size-adjust: 100%;
  transition-delay: 0s, 0s, 0s, 0s;
  transition-duration: 0.15s, 0.15s, 0.15s, 0.15s;
  transition-property: color, background-color, border-color, box-shadow;
  transition-timing-function: ease-in-out, ease-in-out, ease-in-out, ease-in-out;
  user-select: none;
  vertical-align: middle;
  white-space: nowrap;
  width: 86px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.bluess {
  display: inline-block;
  display: inline;
  vertical-align: middle;
  margin: 0;
  padding: 0;
  width: 18px;
  height: 18px;
  background: url("../../assets/blue.png") no-repeat;
  border: none;
  cursor: pointer;
  background-position: -140px 0;
}
.notblues {
  display: inline-block;
  display: inline;
  vertical-align: middle;
  margin: 0;
  padding: 0;
  width: 18px;
  height: 18px;
  background: url("../../assets/blue.png") no-repeat;
  border: none;
  cursor: pointer;
  background-position: -100px 0;
}
</style>
